(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[134],{

/***/ 6485:
/***/ (function(module) {

/*! clipboard-copy. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* global DOMException */

module.exports = clipboardCopy

function makeError () {
  return new DOMException('The request is not allowed', 'NotAllowedError')
}

async function copyClipboardApi (text) {
  // Use the Async Clipboard API when available. Requires a secure browsing
  // context (i.e. HTTPS)
  if (!navigator.clipboard) {
    throw makeError()
  }
  return navigator.clipboard.writeText(text)
}

async function copyExecCommand (text) {
  // Put the text to copy into a <span>
  const span = document.createElement('span')
  span.textContent = text

  // Preserve consecutive spaces and newlines
  span.style.whiteSpace = 'pre'
  span.style.webkitUserSelect = 'auto'
  span.style.userSelect = 'all'

  // Add the <span> to the page
  document.body.appendChild(span)

  // Make a selection object representing the range of text selected by the user
  const selection = window.getSelection()
  const range = window.document.createRange()
  selection.removeAllRanges()
  range.selectNode(span)
  selection.addRange(range)

  // Copy text to the clipboard
  let success = false
  try {
    success = window.document.execCommand('copy')
  } finally {
    // Cleanup
    selection.removeAllRanges()
    window.document.body.removeChild(span)
  }

  if (!success) throw makeError()
}

async function clipboardCopy (text) {
  try {
    await copyClipboardApi(text)
  } catch (err) {
    // ...Otherwise, use document.execCommand() fallback
    try {
      await copyExecCommand(text)
    } catch (err2) {
      throw (err2 || err || makeError())
    }
  }
}


/***/ }),

/***/ 830:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news",
      function () {
        return __webpack_require__(1887);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rV": function() { return /* reexport */ useSettings/* useSettings */.r; }
});

// UNUSED EXPORTS: useBgColor, useClipboard, useTimeFormat

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clipboard-copy/index.js
var clipboard_copy = __webpack_require__(6485);
;// CONCATENATED MODULE: ./src/@core/hooks/useClipboard.tsx
// ** React Imports

// ** Third Party Imports

const isInputLike = (node)=>{
    return node && (node.nodeName === "TEXTAREA" || node.nodeName === "INPUT");
};
const useClipboard = function() {
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const targetRef = useRef(null);
    const handleSuccess = ()=>{
        if (options.onSuccess) {
            options.onSuccess();
        }
        if (options.selectOnCopy && isInputLike(targetRef.current)) {
            targetRef.current.select();
        }
    };
    const handleError = ()=>{
        if (options.onError) {
            options.onError();
        }
        const selectOnError = options.selectOnError !== false;
        if (selectOnError && isInputLike(targetRef.current)) {
            targetRef.current.select();
        }
    };
    const clipboardCopy = (text)=>{
        copy(text).then(handleSuccess).catch(handleError);
    };
    const copyHandler = useCallback((text)=>{
        if (typeof text === "string") {
            clipboardCopy(text);
        } else if (targetRef.current) {
            clipboardCopy(targetRef.current.value);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        copy: copyHandler,
        target: targetRef
    };
};
/* harmony default export */ var hooks_useClipboard = ((/* unused pure expression or super */ null && (useClipboard)));

// EXTERNAL MODULE: ./src/@core/hooks/useSettings.ts
var useSettings = __webpack_require__(1268);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(7484);
;// CONCATENATED MODULE: ./src/@core/hooks/useTimeFormat.tsx
// ** Module Imports


const useTimeFormat = ()=>{
    const { locale  } = useIntl();
    const formatDate = (value, formule)=>dayjs(value).locale(locale).format(formule);
    const formatPlaceholder = (data)=>{
        let placeholder = data;
        if (locale === "ru") {
            placeholder = data.split("").map((item)=>{
                if (item === "m") return "м";
                if (item === "h") return "ч";
                if (item === "d") return "д";
                if (item === "y") return "г";
                return item;
            }).join("");
        }
        return placeholder;
    };
    return {
        formatDate,
        formatPlaceholder
    };
};
/* harmony default export */ var hooks_useTimeFormat = ((/* unused pure expression or super */ null && (useTimeFormat)));

;// CONCATENATED MODULE: ./src/@core/hooks/index.ts







/***/ }),

/***/ 3291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8958);

/* harmony default export */ __webpack_exports__["Z"] = ({
    getNewsList: ()=>"".concat(_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].apiEndpoint */ .Z.apiEndpoint, "/api/").concat(_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].space */ .Z.space, "/database/news/row"),
    getNewDetail: ()=>"".concat(_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].apiEndpoint */ .Z.apiEndpoint, "/api/").concat(_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].space */ .Z.space, "/database/news/row")
});


/***/ }),

/***/ 1887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var effector_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4190);
/* harmony import */ var src_state_manager_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5789);
/* harmony import */ var src_core_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2791);
/* harmony import */ var src_state_manager_landing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2088);
/* harmony import */ var src_configs_db_columns_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1872);
/* harmony import */ var src_configs_db_enum_v2_options__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(662);
/* harmony import */ var src_core_components_spinner__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2503);
/* harmony import */ var src_layouts_default_layout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5113);
/* harmony import */ var src_state_manager_news__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2094);
// ** React Imports


// ** Modules Imports


// ** Source code Imports








const keyValuesKeys = src_configs_db_columns_keys__WEBPACK_IMPORTED_MODULE_6__/* ["default"].keyValues */ .Z.keyValues;
const keyValuesEnum = src_configs_db_enum_v2_options__WEBPACK_IMPORTED_MODULE_7__/* ["default"].keyValues */ .Z.keyValues;
const News = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(549), __webpack_require__.e(102)]).then(__webpack_require__.bind(__webpack_require__, 6102)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6102)
            ]
    },
    ssr: false
});
const NewsPage = ()=>{
    const settings = (0,src_core_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useSettings */ .rV)();
    const { language  } = (0,effector_react__WEBPACK_IMPORTED_MODULE_11__/* .useStore */ .oR)(src_state_manager_global__WEBPACK_IMPORTED_MODULE_3__/* ["default"].locale */ .ZP.locale);
    const { landingDetails  } = (0,effector_react__WEBPACK_IMPORTED_MODULE_11__/* .useStore */ .oR)(src_state_manager_landing__WEBPACK_IMPORTED_MODULE_5__/* ["default"].landing */ .ZP.landing);
    const { data: newsData  } = (0,effector_react__WEBPACK_IMPORTED_MODULE_11__/* .useStore */ .oR)(src_state_manager_news__WEBPACK_IMPORTED_MODULE_10__/* ["default"].news */ .Z.news);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,src_state_manager_landing__WEBPACK_IMPORTED_MODULE_5__/* .getLandingDetail */ .d_)({
            query: {
                $or: [
                    {
                        "data.groupName": "landing"
                    },
                    {
                        "data.groupName": "shared"
                    }
                ],
                $and: [
                    {
                        ["data.".concat(keyValuesKeys.language)]: language === "ru" ? keyValuesEnum.language.ru : keyValuesEnum.language.en
                    }
                ]
            }
        });
        (0,src_state_manager_news__WEBPACK_IMPORTED_MODULE_10__/* .getNewsList */ .I)({
            query: {
                ["data.showToLanding"]: true
            }
        });
    }, [
        language
    ]);
    const isLoading = landingDetails.loading;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_spinner__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                settings: settings
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_layouts_default_layout__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                sx: {
                    height: isLoading ? 0 : "auto",
                    visibility: isLoading ? "hidden" : "visible"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(News, {
                    landingDetails: landingDetails.data,
                    newsItems: newsData
                })
            })
        ]
    });
};
NewsPage.getLayout = (page)=>page;
/* harmony default export */ __webpack_exports__["default"] = (NewsPage);


/***/ }),

/***/ 2094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ getNewsList; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(196);
/* harmony import */ var effector__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8116);
/* harmony import */ var src_configs_news__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3291);



const getNewsList = (0,effector__WEBPACK_IMPORTED_MODULE_2__/* .createEffect */ .GW)(async function() {
    let payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { data  } = await axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post(src_configs_news__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getNewsList */ .Z.getNewsList(), payload);
    return data;
});
const news = (0,effector__WEBPACK_IMPORTED_MODULE_2__/* .createStore */ .MT)({
    data: [],
    count: 0,
    pages: 0,
    loading: true
}).on(getNewsList, (state)=>{
    return {
        ...state,
        loading: true
    };
}).on(getNewsList.doneData, (state, payload)=>{
    return {
        ...state,
        data: payload.data,
        count: payload.count,
        pages: payload.pages,
        loading: false
    };
});

/* harmony default export */ __webpack_exports__["Z"] = ({
    news
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [524,100,515,774,888,179], function() { return __webpack_exec__(830); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);